import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from 'react-select';

const MonthEarlyGoing = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    dept_id: "0",
    action_type: "Fetch",
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  // ✅ Handle Input
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch Departments
  const fetchDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/showdepartment", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      let deptData = [];
      if (Array.isArray(res.data)) deptData = res.data;
      else if (res.data.departments) deptData = res.data.departments;
      else if (res.data.data) deptData = res.data.data;
      else toast.error("Unexpected response from /showdepartment");

      setDepartments(deptData);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ✅ Fetch Monthly Report
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        API_BASE_URL + "/month_early_going",
        {
          start_date: filters.start_date,
          end_date: filters.end_date,
          dept_id: filters.dept_id,
          action_type: filters.action_type,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data.records || []);
      setCurrentPage(1);
      toast.success("Monthly report loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error fetching monthly report");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Search + Pagination
  const filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">
        <ToastContainer />

        {/* 🔹 Navigation Buttons */}
        <div className="mb-3 d-flex flex-wrap gap-2">
          <a href="/Early-going" className="btn btn-outline-secondary btn-sm">
            Day Wise Early Going Report
          </a>
          <a href="/Weekly-going" className="btn btn-outline-secondary btn-sm">
            Weekly Wise Early Going
          </a>
          <a href="/Monthly-going" className="btn btn-info btn-sm">
            Monthly Early Going Report
          </a>
        </div>

        {/* 🔹 Filter Form */}
        <div className="card shadow-sm mb-4">
          <div className="card-header">
            <span className="card-header-title me-2">Filter by Date</span>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                {/* From Date */}
                <div className="col-md-3">
                  <label htmlFor="start_date">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="start_date"
                    value={filters.start_date}
                    onChange={handleInput}
                    required
                  />
                </div>

                {/* To Date */}
                <div className="col-md-3">
                  <label htmlFor="end_date">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    value={filters.end_date}
                    onChange={handleInput}
                    required
                  />
                </div>

                {/* Department */}
                <div className="col-md-3">
                  <label htmlFor="dept_id">Department</label>
                  
  <Select
    name="dept_id"
    value={
      departments
        .map((dept) => ({
          value: dept.department_id || dept.id,
          label: dept.department_name,
        }))
        .find((d) => d.value === filters.dept_id) || null
    }
    onChange={(selected) =>
      handleInput({
        target: {
          name: "dept_id",
          value: selected ? selected.value : "0", // same as "All Department"
        },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id || dept.id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All Department"
    className="basic-single"
  />
                </div>

                {/* Submit */}
                <div className="col-md-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Get
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* 🔹 Monthly Report Table */}
        <div className="card">
          <h6 className="card-header">Monthly Early Going Report</h6>
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div
                className="d-flex align-items-center gap-2"
                style={{ width: "auto", minWidth: "220px" }}
              >
                <DownloadButtons data={filteredItems} filename="Monthly_Early_Going_Report" />
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>

              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search..."
                style={{ width: "200px" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead style={{ backgroundColor: "#7d858369" }}>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Department</th>
                      <th>No of Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.department}</td>
                          <td>{row.early_hours}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-danger fw-bold">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MonthEarlyGoing;
